/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { ATTENDANCE_REPORT_STATE } from "./attendance-report-constant";


const useAttendanceReportService = () => {
    const [payslipReportTableUILoading, setPayslipReportTableUILoading] = useState(false);
    const [attendanceReportListData, setAttendanceReportListData] = useState([]);
    const [payslipReportSummary, setPayslipReportSummary] = useState({})
    const [payslipReportData, setPayslipReportData] = useState({})
    const { fetchData } = useAPIHandler()
    const [attendenceReportInputs, setAttendenceReportInputs] = useState(ATTENDANCE_REPORT_STATE)
    const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
    const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
    const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [attendenceReportPDFData, setAttendenceReportPDFData] = useState([]);
    const [attendenceSummary, setAttendenceReportSummary] = useState({})
    const [organizationInfo, setOrganizationInfo] = useState({})
    const [dataFetched, setDataFetched] = useState(false);
    const [loadingAllSalaryReport, setLoadingAllSalaryReport] = useState(false);

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setAttendenceReportInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    
    const fetchAllAttendenceReportEmpList = async () => {
        setPayslipReportTableUILoading(true);
        try {
            const { report_month } = attendenceReportInputs;
            logger.log(report_month,attendenceReportInputs, "report_month")
            const response = await fetchData({
                url: `/attendance/approve-attendance?date=${report_month}-10&page=${currentPage + 1}&pageSize=${rowsPerPage}&search=${searchQuery}`,
                method: 'GET'
            });
            setAttendanceReportListData(response?.data?.attendanceRecords);
            const totalPageCount = response?.data?.pagination?.totalPages || 1;
            setTotalPages(totalPageCount);
            setPayslipReportTableUILoading(false)
        } catch {
            setPayslipReportTableUILoading(false)
        }
    }


    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    
    const fetchAttendanceReportPdf = async () => {
        setLoadingAllSalaryReport(true);
        try {
            const { report_month } = attendenceReportInputs;

            if (report_month) {
                const parts = report_month.split("-");
                const year = parts[0];
                let month = parts[1];
                if (month.startsWith("0")) {
                    month = month.substring(1);
                }
                
                const response = await fetchData({
                    url:`/report/attendance/?month=${month}&year=${year}&order_type=ASC`,
                    method: 'GET'
                });
                setAttendenceReportPDFData(response?.data?.attendance);
                setAttendenceReportSummary(response?.data?.additional_details);
                setOrganizationInfo(response?.data?.org_details);
                setDataFetched(true)
                setLoadingAllSalaryReport(false)
            }

        } catch {
            setLoadingAllSalaryReport(false)
        }
    }
    useEffect(() => {
        fetchAllAttendenceReportEmpList();
    }, [setAttendenceReportInputs, attendenceReportInputs,rowsPerPage, currentPage, searchQuery])
    
    
    return {
        attendanceReportListData,
        attendenceReportInputs,
        handleChange,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        rowsPerPage,
        currentPage,
        totalPages,
        searchQuery,
        setSearchQuery,
        fetchAttendanceReportPdf,
        attendenceReportPDFData,
        attendenceSummary,
        organizationInfo,
        dataFetched,
        loadingAllSalaryReport
    }
}

export default useAttendanceReportService